import { Injectable, Type } from '@angular/core';
import { AttributeType } from './models/attribute-type.enum';
import { AttributeComponent } from './interfaces/attribute.component';
import { TextboxComponent } from './attribute-components/textbox/textbox.component';
import { IntegerComponent } from './attribute-components/integer/integer.component';
import { DecimalComponent } from './attribute-components/decimal/decimal.component';
import { CheckboxComponent } from './attribute-components/checkbox/checkbox.component';
import { DateComponent } from './attribute-components/date/date.component';
import { TimeComponent } from './attribute-components/time/time.component';
import { DateTimeComponent } from './attribute-components/date-time/date-time.component';
import { SelectComponent } from './attribute-components/select/select.component';
import { MultiSelectComponent } from './attribute-components/multi-select/multi-select.component';

export interface IComponentTypeProvider {
  getComponent(attributeType: AttributeType): Type<AttributeComponent>;
}

@Injectable({
  providedIn: 'root'
})
export class ComponentTypeProvider implements IComponentTypeProvider {
  private _componentTypes = new Map<AttributeType, Type<AttributeComponent>>([
    [AttributeType.String, TextboxComponent],
    [AttributeType.Integer, IntegerComponent],
    [AttributeType.Decimal, DecimalComponent],
    [AttributeType.Checkbox, CheckboxComponent],
    [AttributeType.Date, DateComponent],
    [AttributeType.Time, TimeComponent],
    [AttributeType.DateTime, DateTimeComponent],
    [AttributeType.Select, SelectComponent],
    [AttributeType.MultiSelect, MultiSelectComponent]
  ]);

  constructor() { }

  public getComponent(attributeType: AttributeType): Type<AttributeComponent> {
    return this._componentTypes.get(attributeType) ?? TextboxComponent;
  }
}
